module.exports = __webpack_public_path__ + "img/jxianhua.658d7682.gif";